export default __webpack_public_path__ + "static/media/unversalKlein.c487ec49.jpg";